import React, { useRef, useCallback, useEffect } from "react";

import { generate } from "utils/array";

import styles from "./HorizontalGrid.module.css";

const blockSwipeBack = (element) => (e) => {
  e.stopPropagation();
  if (!element.contains(e.target)) {
    return;
  }

  e.preventDefault();
  const max = element.scrollWidth - element.offsetWidth;
  const scrollPosition =
    Math.abs(e.deltaX) > Math.abs(e.deltaY)
      ? element.scrollLeft + e.deltaX
      : element.scrollLeft + e.deltaY;
  element.scrollLeft = Math.max(0, Math.min(max, scrollPosition));
};

const useBlockSwipeBack = (ref) => {
  useEffect(() => {
    const current = ref.current;
    document.addEventListener("mousewheel", blockSwipeBack(current), {
      passive: false,
    });
    return () => {
      document.removeEventListener("mousewheel", blockSwipeBack(current));
    };
  }, [ref]);
};

const HorizontalGrid = ({ rows, itemCount, tileForIndex }) => {
  const scrollElementRef = useRef(null);
  useBlockSwipeBack(scrollElementRef);

  const rowColToI = useCallback(
    (row, col) => {
      return col * rows + row + 1;
    },
    [rows]
  );

  const numberOfColumns = Math.ceil(itemCount / rows);

  return (
    <div className={styles.wrapper} ref={scrollElementRef}>
      <div className={styles.flexGrid}>
        {generate(numberOfColumns + 1, (_, col) => (
          <div>
            {generate(rows, (_, row) => {
              if (col === numberOfColumns) {
                return <div className={styles.margin} />;
              }
              const index = rowColToI(row, col) - 1;
              return tileForIndex(
                index,
                row === rows - 1,
                col === numberOfColumns - 1
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HorizontalGrid;
